import React from "react";

const Loader = () => {
  return (
    <div className="relative w-14 h-14 flex items-center justify-center">
      <div className="absolute w-[33.6px] h-[33.6px] border-[6.7px] border-[#12b8e6] border-b-transparent border-l-transparent rounded-full animate-spin-reverse" />
      <div className="absolute w-14 h-14 border-[6.7px] border-[#12b8e6] border-r-transparent border-t-transparent rounded-full animate-spin" />
      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
          @keyframes spin-reverse {
            to {
              transform: rotate(-360deg);
            }
          }
          .animate-spin {
            animation: spin 0.5s infinite linear;
          }
          .animate-spin-reverse {
            animation: spin-reverse 0.75s infinite linear;
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
